module.exports = __webpack_public_path__ + "c2c1d865ba5236be952df24e1b34880f.svg";